var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#17B67C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76673 11.1397C6.64943 11.0219 6.51 10.9284 6.35645 10.8646C6.20291 10.8008 6.03828 10.7679 5.872 10.7679C5.70573 10.7679 5.54109 10.8008 5.38755 10.8646C5.234 10.9284 5.09458 11.0219 4.97727 11.1397C4.85943 11.257 4.76592 11.3965 4.70212 11.55C4.63831 11.7035 4.60547 11.8682 4.60547 12.0345C4.60547 12.2007 4.63831 12.3654 4.70212 12.5189C4.76592 12.6724 4.85943 12.8119 4.97727 12.9292L9.5265 17.4784L9.60033 17.5522C9.71129 17.6634 9.84308 17.7516 9.98817 17.8117C10.1332 17.8719 10.2888 17.9029 10.4458 17.9029C10.6029 17.9029 10.7584 17.8719 10.9035 17.8117C11.0486 17.7516 11.1804 17.6634 11.2914 17.5522L19.1488 9.69482C19.26 9.58386 19.3482 9.45207 19.4083 9.30698C19.4685 9.1619 19.4995 9.00638 19.4995 8.84931C19.4995 8.69225 19.4685 8.53672 19.4083 8.39164C19.3482 8.24656 19.26 8.11477 19.1488 8.00381L19.0504 7.90537C18.9394 7.7942 18.8076 7.70601 18.6625 7.64584C18.5174 7.58566 18.3619 7.55469 18.2048 7.55469C18.0478 7.55469 17.8923 7.58566 17.7472 7.64584C17.6021 7.70601 17.4703 7.7942 17.3593 7.90537L10.4441 14.8171L6.76673 11.1397Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.77ef77eca758f8ae675f81f5f6facd10.svg";
export { ForwardRef as ReactComponent };